export const tryParse = (rawValue, fallback) => {
  try {
    return rawValue == undefined ? fallback : JSON.parse(rawValue);
  } catch {
    return fallback;
  }
};
